<nb-card>
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <span><strong>Cobranza</strong></span>
  </nb-card-header>

  <nb-card-body>
    
    <div class="filters-container">

      <input nbInput
            placeholder="Buscar cliente, número o plan..."
            (keyup)="applyFilter($event)"
            class="search-input">

      <select nbSelect [(ngModel)]="statusFilter" (ngModelChange)="applyStatusFilter($event)" class="status-select">
        <option value="">Todos</option>
        <option value="pendiente">Pendiente</option>
        <option value="facturado">Facturado</option>
        <option value="pagado">Pagado</option>
        <option value="suspendido">Suspendido</option>
        <option value="cancelado">Cancelado</option>
      </select>

    </div>

    <div class="table-container">
      <table mat-table [dataSource]="dataClients" class="payments-table">

        <!-- CLIENT NUMBER -->
        <ng-container matColumnDef="clientNumber">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let e">
            <span class="badge-number">{{ e.clientNumber }}</span>
          </td>
        </ng-container>

        <!-- CLIENTE -->
        <ng-container matColumnDef="cliente">
          <th mat-header-cell *matHeaderCellDef>Cliente</th>
          <td mat-cell *matCellDef="let e">
            <div class="client-cell">
              <div class="name">{{ e.cliente }}</div>
              <div class="sub">{{ e.nombreComercial }}</div>

              <!-- estado de ciclo -->
              <div *ngIf="!e.billingCycleId" class="no-cycle">
                ⚠ Sin ciclo activo
              </div>
            </div>
          </td>
        </ng-container>

        <!-- CONTACTO -->
        <ng-container matColumnDef="contacto">
          <th mat-header-cell *matHeaderCellDef>Contacto</th>
          <td mat-cell *matCellDef="let e">
            <input nbInput class="input-medium" size="small" [disabled]="!e.hasCycle" [(ngModel)]="e.contacto">
          </td>
        </ng-container>

        <!-- PLAN -->
        <ng-container matColumnDef="plan">
          <th mat-header-cell *matHeaderCellDef>Plan</th>
          <td mat-cell *matCellDef="let e">
            <select nbSelect [(ngModel)]="e.plan" [disabled]="!e.hasCycle">
              <option *ngFor="let p of plans" [value]="p.title">
                {{ p.title }}
              </option>
            </select>
          </td>
        </ng-container>

        <!-- MONTO -->
        <ng-container matColumnDef="monto">
          <th mat-header-cell *matHeaderCellDef>Monto</th>
          <td mat-cell *matCellDef="let e">
              <input nbInput
                type="number"
                class="input-medium"
                [(ngModel)]="e.monto"
                [disabled]="!e.hasCycle">
          </td>
        </ng-container>

        <!-- FORMA DE PAGO -->
        <ng-container matColumnDef="formaPago">
          <th mat-header-cell *matHeaderCellDef>Forma pago</th>
          <td mat-cell *matCellDef="let e">
            <select nbSelect [(ngModel)]="e.formaPago" [disabled]="!e.hasCycle">
              <option value="">Seleccionar</option>
              <option value="whatsapp">WhatsApp</option>
              <option value="correo">Correo</option>
              <option value="llamada">Llamada</option>
              <option value="transferencia">Transferencia</option>
              <option value="stripe">Stripe</option>
            </select>
          </td>
        </ng-container>

        <!-- DIA CORTE -->
        <ng-container matColumnDef="diaCorte">
          <th mat-header-cell *matHeaderCellDef>Corte</th>
          <td mat-cell *matCellDef="let e">
            <input
              nbInput
              type="date"
              class="input-medium"
              [(ngModel)]="e.cycleStartDate"
              [disabled]="!e.hasCycle"
              >
          </td>
        </ng-container>

        <!-- DIA COBRO -->
        <ng-container matColumnDef="diaCobro">
          <th mat-header-cell *matHeaderCellDef>Dia de pago</th>
          <td mat-cell *matCellDef="let e">
            <input
              nbInput
              type="date"
              class="input-medium"
              [(ngModel)]="e.diaCobro"
              [disabled]="!e.hasCycle"
              >
          </td>
        </ng-container>

        <!-- FACTURA -->
        <ng-container matColumnDef="factura">
          <th mat-header-cell *matHeaderCellDef>Factura</th>
          <td mat-cell *matCellDef="let e">
            <input nbInput size="small" class="input-medium" [disabled]="!e.hasCycle" [(ngModel)]="e.factura">
          </td>
        </ng-container>

        <!-- FACTURA PDF -->
        <ng-container matColumnDef="facturaFile">
          <th mat-header-cell *matHeaderCellDef>Factura PDF</th>
          <td mat-cell *matCellDef="let e">

            <button nbButton size="tiny" status="info"
                    (click)="uploadFile(e, 'Factura')"
                    [disabled]="!e.paymentId || (e.status !== 'facturado' && e.status !== 'pagado')">
              Subir
            </button>

            <button *ngIf="e.fileInvoice?.url"
              nbButton size="tiny"
              status="success"
              (click)="viewFile(e.fileInvoice.url)">
              Ver
            </button>

            <button *ngIf="e.fileInvoice?.url"
                    nbButton size="tiny"
                    status="danger"
                    (click)="removeInvoice(e)">
              Eliminar
            </button>

            <div *ngIf="!e.paymentId" class="file-warning">
              Guardar pago primero
            </div>

          </td>
        </ng-container>

        <!-- COMPROBANTE -->
        <ng-container matColumnDef="comprobante">
          <th mat-header-cell *matHeaderCellDef>Pago</th>
          <td mat-cell *matCellDef="let e">

            <button nbButton size="tiny" status="info"
                    (click)="uploadFile(e, 'Comprobante de pago')"
                    [disabled]="!e.paymentId || (e.status !== 'facturado' && e.status !== 'pagado')">
              Subir
            </button>

            <div *ngIf="e.paymentProofFiles?.length">
              <div *ngFor="let file of e.paymentProofFiles; let i = index" class="file-item">
                <button nbButton size="tiny" status="success"
                        (click)="viewFile(file.url)">
                  Ver {{ i + 1 }}
                </button>

                <button nbButton size="tiny" status="danger"
                        (click)="removeProof(e, i)">
                  Eliminar
                </button>
              </div>
            </div>

            <div *ngIf="!e.paymentId" class="file-warning">
              Guardar pago primero
            </div>

          </td>
        </ng-container>

        <!-- NOTES -->
        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef>Notas</th>
          <td mat-cell *matCellDef="let e">
            <input nbInput size="small" class="input-large" [disabled]="!e.hasCycle" [(ngModel)]="e.notes" placeholder="Comentarios del pago">
          </td>
        </ng-container>

        <!-- STATUS -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let e">
            <select
              nbSelect
              [(ngModel)]="e.status"
              [disabled]="!e.hasCycle"
              [class]="getStatusClass(e.status)">
              <option value="pendiente">Pendiente</option>
              <option value="facturado">Facturado</option>
              <option value="pagado">Pagado</option>
              <option value="suspendido">Suspendido</option>
              <option value="cancelado">Cancelado</option>
            </select>
          </td>
        </ng-container>

        <!-- ACCIONES -->
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let e">

            <div class="btn-actions-container">

              <!-- SIN ciclo -->
              <button *ngIf="!e.hasCycle"
                      nbButton
                      size="tiny"
                      status="info"
                      (click)="createCycle(e)">
                Crear ciclo
              </button>

              <!-- CON ciclo -->
              <ng-container *ngIf="e.hasCycle">

                <button nbButton
                        size="tiny"
                        status="success"
                        (click)="saveRow(e)">
                  Guardar pago
                </button>

                <button nbButton
                        size="tiny"
                        status="primary"
                        (click)="addExtraCharge(e)"
                        [disabled]="!e.paymentId || e.status !== 'pagado'">
                  Excedente
                </button>

                <button nbButton
                        size="tiny"
                        status="warning"
                        (click)="renewCycle(e)">
                  Renovar plan
                </button>

                <button nbButton
                        size="tiny"
                        status="info"
                        (click)="viewHistory(e)">
                  Historial
                </button>

              </ng-container>

            </div>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;" class="row-hover"></tr>

      </table>
    </div>

  </nb-card-body>
</nb-card>